import { render, staticRenderFns } from "./ExpoShowAllCards.vue?vue&type=template&id=38c5f7ff&scoped=true&"
import script from "./ExpoShowAllCards.vue?vue&type=script&lang=js&"
export * from "./ExpoShowAllCards.vue?vue&type=script&lang=js&"
import style0 from "./ExpoShowAllCards.vue?vue&type=style&index=0&id=38c5f7ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5f7ff",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardText, BCard, BCardGroup, BButton} from 'bootstrap-vue'
    installComponents(component, {BCardText, BCard, BCardGroup, BButton})
    

export default component.exports